export default __webpack_public_path__ + "static/media/Bagirwa Totem.d31cc32f.jpg";